import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

//import StepItem from '../../components/StepItem'

class LiveInfo extends Component {
  state = {};
  _isMounted = false;
  interval = null;
  componentDidMount = () => {
    this._isMounted = true;
    const { contentSerial } = this.props.childProps;
    //console.log(contentSerial)
    this._getData(contentSerial);
  };

  componentWillUnmount = () => {
    this._isMounted = false;
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    //console.log(this.props.location.pathname)
    //console.log(nextProps.location)
    return this.props.childProps.subTitle !== nextProps.childProps.subTitle;
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    ////console.log(nextProps)

    if (this.props.childProps.subTitle !== nextProps.childProps.subTitle) {
      this._getData(nextProps.childProps.contentSerial);
    }
  };
  _getData = async (contentSerial) => {
    const { existLive } = this.props.childProps;
    const result = await this._getDataApi(contentSerial);
    const intReturn = result.data[0].intReturn;
    const str = result.data[0].str;
    const nextLiveInfo = result.data[0].listData;
    //console.log(contentSerial)
    //console.log(str)
    //console.log(nextLiveInfo)
    //console.log('=====================>다시불러옴.')
    if (this._isMounted) {
      if (intReturn === 0) {
        this.setState({
          str,
          nextLiveInfo,
        });
      } else {
        this.setState({
          str,
        });
      }
      ////console.log(str, intReturn)

      if (str !== '') {
        if (intReturn === 0) {
          existLive(true);
        } else {
          existLive(true);
        }
      } else {
        if (intReturn === 0) {
          existLive(true);
        } else {
          existLive(false);
        }
      }
    }
  };

  _getDataApi = (contentSerial) => {
    const { apiUrl } = this.props;
    return axios
      .post(apiUrl + '/contentLiveInfo', {
        params: {
          contentSerial: contentSerial,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };

  _renderItem = () => {
    const { nextLiveInfo } = this.state;

    const list = nextLiveInfo.map((item, index) => {
      return (
        item.mm +
        '.' +
        item.dd +
        item.weekName +
        ' ' +
        item.startTime +
        '-' +
        item.part +
        '화 / '

        /*
                <div style={{ marginTop: 7}} key={index}>
                    <div style={{float: 'left', marginRight: 8}}>
                        <img src={item.img} style={{width: 80 }}/>
                    </div>
                    <div style={{paddingLeft: 5, marginTop: 10, height: 45, verticalAlign: 'center'}}>
                        <div>{item.subTitle}</div>
                        <div>{item.nextDay}({item.wn}) {item.nextTime}</div>
                    </div>
                </div>
                */
      );
    });

    return list;
  };

  render() {
    const { str, nextLiveInfo } = this.state;
    return (
      <Fragment>
        <div className="timelineliveinfo">
          {str === '' || str === undefined || str === null ? null : (
            <div className="bo">
              <span>본방</span> {str}
            </div>
          )}

          {nextLiveInfo ? (
            <div className="jae">
              <span className="">재방</span> {this._renderItem()}
            </div>
          ) : null}
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(LiveInfo));
